import React from 'react'
import './Pagination.scss'

// Instead of clickable links in Pagination.jsx, this component has clickable things that trigger a callback.
// any benefit to combining this and Pagination.jsx?

const PaginatedItems = ({ currentPage, numPages=0, onClick, ...props }) => {
  //
  // Create array of page markers, truncating the list in specific circumstances. This could probably be more elegant if i was smarter.
  //
  let paginationArray
  let ellipsis1
  let ellipsis2

  numPages = parseInt(numPages) || 0
  if (numPages == 0) {
    return null
  }

  if (numPages > 5) {
    //first couple pages condition.
    //If pages are more than 5, but current page is less than 4, the fifth pagination item will be the final page, with an added ellipsis.
    if (currentPage <= 3) {
      paginationArray = [1, 2, 3, 4, numPages]
      ellipsis1 = false
      ellipsis2 = true
    }

    //Final last pages condition. first ellipsis shows, second ellipsis does not, because we're in the final couple of pages.
    else if (currentPage >= numPages - 2) {
      ellipsis1 = true
      ellipsis2 = false
      paginationArray = [1, numPages - 3, numPages - 2, numPages - 1, numPages]
    }

    //Finally, in the middle of the pagination, Both ellipses show, first item is first page, last item is the last page. //if (numPages > 5 && currentPage > 3)
    else {
      paginationArray = [
        1,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        numPages,
      ]
      ellipsis1 = true
      ellipsis2 = true
    }
  }
  //If 5 pages or less, it just counts through em, and can show less than the max of 5.
  else {
    paginationArray = [...Array(numPages).keys()].map(i => i + 1)
    ellipsis1 = false
    ellipsis2 = false
  }

  const containerClasses = () => {
    return `pagination ${
      ellipsis1 ? 'ellipsis-a-active' : 'ellipsis-a-inactive'
    } ${ellipsis2 ? 'ellipsis-b-active' : 'ellipsis-b-inactive'}`
  }

  return (
    <nav className={`nav__break-category-pagination ${props.className}`}>
      <div className="container">
        <ul className={containerClasses()}>
          {paginationArray.map((num, i) => (
            <li
              key={`page-key-${i}`}
              className={
                'pagination__item ' +
                (currentPage === num ? 'page-active' : 'page-inactive') +
                ' item-num-' +
                num
              }
            >
              <span
                role="listitem"
                className={`link-item`}
                onKeyDown={() => {
                  onClick(num)
                }}
                onClick={() => {
                  onClick(num)
                }}
              >
                {num}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}

export default PaginatedItems
